module.exports = __webpack_public_path__ + "img/truck_mobile.b1844d46.png";